//Built-in libraries
import { useState } from 'react';

//Third party libraries
import { useLocation, useNavigate } from 'react-router';

//Custom components
import Table from '@/components/Table/Table';

//Services

//Assets and Miscellaneous

//Component Begin
export default function TableViewOpportunities({ opportunities }: { opportunities: any }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoadingData, _setIsLoadingData] = useState(false);
  const [_perPage, setperPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, _setTotalPage] = useState<number>(1);
  const totalTask = Math.floor(Math.random() * (700 - 100) + 700);
  const completed_task = Math.floor(Math.random() * (750 + 1));

  const onPageChangeHandler = (direction: string) => {
    if (direction === 'prev') {
      setPage((prevState) => (prevState > 1 ? page - 1 : 1));
    } else if (direction === 'next') {
      setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
    }
  };

  return (
    <Table
      tableHead={['Project Name', 'Status', 'Approvals', 'Tasks', 'Deliverables', 'Milestones', 'Project Lead', 'Project Health']}
      currentPage={page}
      totalPage={totalPage}
      perPageHandler={(v) => setperPage(+v.target.value)}
      pageChangeHandler={onPageChangeHandler}
    >
      {isLoadingData &&
        [1, 2, 3, 4, 5].map((num) => (
          <tr key={num} className='animate-pulse'>
            <td className='px-6 py-4 whitespace-nowrap w-full'>
              <div className='flex items-center'>
                <span className='inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500'>
                  <span className='font-medium leading-none text-green-500 font-bold'></span>
                </span>
                <div className='ml-4 h-2 w-1/3'>
                  <div className='h-1 w-full rounded-md bg-gray-500 mb-2'></div>
                  <div className='h-1 w-1/2 rounded-md bg-gray-500'></div>
                </div>
              </div>
            </td>
            <td className='px-6 py-4 whitespace-nowrap w-full'>
              <div className='h-1 w-1/3 rounded-md bg-gray-500 mb-2'></div>
              <div className='h-1 w-1/2 rounded-md bg-gray-500'></div>
            </td>
            <td className='whitespace-nowrap w-full text-center'>
              <span className='h-4 w-1/2 inline-flex rounded-full bg-gray-500'></span>
            </td>
            <td className='px-6 py-4 whitespace-nowrap w-full'>
              <div className='h-2 rounded-md bg-gray-500 mb-2'></div>
            </td>
            <td className='px-6 py-4 whitespace-nowrap text-right text-sm font-medium'>
              <a href='#' className='block h-1 w-2 rounded-md bg-gray-500 mb-2'></a>
            </td>
          </tr>
        ))}
      {!isLoadingData &&
        opportunities !== null &&
        opportunities.map((opportunity: any) => (
          <tr
            key={opportunity.opportunityInfo.ID}
            className='hover:bg-green-50 cursor-pointer w-ful'
            onClick={() => navigate(`${location.pathname}/${opportunity.opportunityInfo.docId}`)}
          >
            <td className='px-6 py-4 whitespace-nowrap'>
              <div className='text-sm text-gray-900 flex flex-col'>
                <span>{opportunity.opportunityInfo.name}</span>
                <span className='text-xs text-neutralColor-normal'>
                  {opportunity.opportunityInfo.address}, {opportunity.opportunityInfo.city}, {opportunity.opportunityInfo.state}, {'no Zip'}
                </span>
              </div>
            </td>
            <td className='px-6 py-4 whitespace-nowrap'>
              {completed_task === totalTask && (
                <p className='text-xs border-2 border-green-500 bg-green-100 px-2 py-0.5 text-green-600 rounded-md font-medium'>
                  Completed
                </p>
              )}
              {completed_task !== totalTask && (
                <p className='text-xs border-2 border-yellow-400 bg-yellow-100 px-2 py-0.5 text-yellow-700 rounded-md font-medium'>
                  In Progress
                </p>
              )}
            </td>
            <td className='px-6 py-4 whitespace-nowrap'>10/12</td>
            <td className='px-6 py-4 whitespace-nowrap'>69/120</td>
            <td className='px-6 py-4 whitespace-nowrap'>43/121</td>
            <td className='px-6 py-4 whitespace-nowrap'>5/18</td>
            <td className='px-6 py-4 whitespace-nowrap'>
              <div className='flex items-center'>
                <img
                  className='h-16 w-16 rounded-full object-cover object-center'
                  src='https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80'
                  alt=''
                />

                <div className='ml-4'>
                  <div className='text-sm font-medium text-gray-900'>
                    <span>Melissa William</span>
                  </div>
                </div>
              </div>
            </td>
            <td className='px-6 py-4 whitespace-nowrap'>
              <div className='w-full bg-gray-200 rounded-full h-5'>
                <div className='w-1/2 bg-green-500 h-full rounded-full px-2 py-1 text-white flex items-center text-xs font-bold'>25%</div>
              </div>
            </td>
          </tr>
        ))}
    </Table>
  );
}
